import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Card from '../../shared/components/UIElements/Card';
import Button from '../../shared/components/FormElements/Button/Button';
import Input from '../../shared/components/FormElements/Input/Input';
import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import { useHttpClient } from '../../shared/hooks/http-hook';
import { useForm } from '../../shared/hooks/form-hook';
import { VALIDATOR_MINLENGTH } from '../../shared/util/validator';
import './Auth.css';

const NewPassword = () => {
    const token = useParams().token;
    const [isUpdated, setIsUpdated] = useState(false);
    const [userId, setUserId] = useState();
    const {isLoading, error, sendRequest, clearError} = useHttpClient();
    const [formState, inputHandler] = useForm(
        {
          password: {
            value: '',
            isValid: false
          }
        },
        false
      );


    useEffect(()=>{
      const fetchUser = async() => {
        const responseData = await sendRequest(process.env.REACT_APP_BACKEND_URL_USER+`/newpassword/${token}`,'GET',null,{'Content-type':'application/json'});
        setUserId(responseData.user);
      }
      fetchUser();
    },[token, sendRequest, setUserId]);
      

      const passwordSubmitHandler = async(event) => {
        event.preventDefault();

        const responseData = await sendRequest(process.env.REACT_APP_BACKEND_URL_USER+`/newpassword/${token}`, 'POST',
        JSON.stringify({
            userId: userId,
            token: token,
            password: formState.inputs.password.value
        }),
        {
            'Content-Type': 'application/json'
        }
        );

        if (responseData.message === "success") {
          setIsUpdated(true);
        }
    }; 

    if (isUpdated) {
      return <div className='thank-you-message'>
        <h3>Password is successfully updated.</h3>
        <Button to="/auth">Login</Button>
      </div>
    }

    return <React.Fragment>
        <ErrorModal error={error} onClear={clearError}/>
        <div className='loginpage-container'>
        {isLoading && <LoadingSpinner asOverlay />}
        <div className='vaceai-auth'>VACE.AI</div>
        <Card className="authentication">
          <h3>Set Your New Password</h3>
          <hr />
          <form onSubmit={passwordSubmitHandler}>
            <Input
                element="input"
                id="password"
                type="text"
                label="Password"
                validators={[VALIDATOR_MINLENGTH(8)]}
                errorText="Password needs to be 8 characters or longer."
                onInput={inputHandler}
            />
            <div className="authentication-button-submit">
              <div className='submit-button'>
                <Button type="submit" disabled={!formState.isValid} transparent>
                  <p style={{ color: 'white', marginBottom: 0, marginTop: 0 }}>Register</p>
                </Button>
              </div>
            </div>
          </form>
        </Card>
        </div>
    </React.Fragment>

};

export default NewPassword;